import { Skeleton } from '@tecsinapse/cortex-react'
import React from 'react'
import { AnuncioCard } from '@/core/components/anuncio-card'
import { ANUNCIO_ALEATORIO } from '../data/anuncio-aleatorio-query'
import { useQuery } from '@tanstack/react-query'
import {
  AnuncioAleatorioQueryQuery,
  AnuncioAleatorioQueryQueryVariables
} from '../../../core/types/graphql'
import { request } from '../../../core/utils/request'

export const InfoCard = () => {
  const { data, isLoading: loading } = useQuery({
    queryKey: ['anuncioAleatorio'],
    queryFn: async () =>
      await request<
        AnuncioAleatorioQueryQuery,
        AnuncioAleatorioQueryQueryVariables
      >(ANUNCIO_ALEATORIO)
  })

  if (loading) return <Skeleton className={'w-[20%] rounded-micro'} />

  if (data?.anuncioAleatorio)
    return (
      <div className={'rounded-micro w-[20%] h-[22.5rem]'}>
        <AnuncioCard
          titulo={data?.anuncioAleatorio.titulo}
          link={data?.anuncioAleatorio.link}
          linkTarget={data?.anuncioAleatorio.linkTarget}
          idArquivo={data?.anuncioAleatorio?.arquivo?.id}
        />
      </div>
    )

  return null
}
